import useRecordUserSessionSinceCalled from '@/hooks/useRecordUserSessionSinceCalled';
import { deleteCookie } from 'cookies-next';
import { useEffect, useRef } from 'react';
import cookiesConstants from '@/constants/cookies.constants';
export default function KlaviyoLimitedSpecialOffer({
  shouldShow,
}: {
  shouldShow: boolean;
}) {
  const executed = useRef<boolean>(false);
  const elapsedTime = useRecordUserSessionSinceCalled(shouldShow);
  useEffect(() => {
    if (shouldShow === false) return;

    if (elapsedTime < 12) return;

    if (typeof window !== 'undefined' && !executed.current) {
      deleteCookie(
        cookiesConstants.COOKIES.KLAVIYO_LIMITED_SPECIAL_OFFER.name
      );
      executed.current = true;
      window._klOnsite.push(['openForm', 'SLfc39']);
    }
  }, [elapsedTime, shouldShow]);

  return null;
}
